import './YoutubeCarousel.css'
import { Carousel } from '@mantine/carousel';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import { useAppContext } from '../../../context/AppState/AppContext';
// import Autoplay from 'embla-carousel-autoplay';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Center, Modal } from '@mantine/core';

// const timeToAutoplay = 5000

export default function YoutubeCarousel() {
    // const autoplay = useRef(Autoplay({ delay: timeToAutoplay }));
    const { jsonMedia, jsonTexts } = useAppContext();

    const texts = jsonTexts?.inicio?.youtubeCarousel
    const carouselData = jsonMedia?.inicio?.youtubeCarousel

    const [selectedVideo, setSelectedVideo] = useState(null);

    return (
        <div className="YoutubeCarousel-main-container">
            <SectionTitle upText={texts?.subtitleTag} downText={texts?.title} />

            {carouselData && carouselData?.length > 0 &&
                <Carousel
                    slideSize={{ base: "100%", sm: "50%", md: '25%' }}
                    loop
                    align="start"
                    slideGap={24}
                    slidesToScroll={{ base: 1, sm: 2, md: 4 }}
                    // plugins={[autoplay.current]}
                    withIndicators
                    withControls
                >
                    {carouselData.map(item => (
                        <Carousel.Slide key={item}>
                            {/* Miniatura que abre el modal */}
                            <img
                                src={`https://img.youtube.com/vi/${getVideoId(item)}/hqdefault.jpg`}
                                alt="YouTube thumbnail"
                                style={{
                                    borderRadius: 'var(--border-radius-md)',
                                    width: '100%',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setSelectedVideo(item)}
                                className='YoutubeCarousel-placeholder-image'
                            />
                        </Carousel.Slide>
                    ))}
                </Carousel>
            }

            <Center mt={{ base: 0, sm: '30px' }}>
                {texts?.buttonText && texts?.buttonRedirect &&
                    <Button
                        bg="var(--color-tertiary)"
                        fw="normal"
                        size='lg'
                        target="_blank"
                        component={Link}
                        to={texts?.buttonRedirect}
                    >
                        {texts?.buttonText}
                    </Button>
                }
            </Center>

            {/* Modal con el iframe */}
            <Modal
                opened={!!selectedVideo}
                onClose={() => setSelectedVideo(null)}
                size="xl"
                centered
                overlayProps={{ backgroundOpacity: 0.6, blur: 4 }}
            >
                {selectedVideo && (
                    <div onClick={e => e.stopPropagation()}>
                        <iframe
                            width="100%"
                            height="480"
                            src={selectedVideo.replace("watch?v=", "embed/")}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        ></iframe>
                    </div>
                )}
            </Modal>
        </div>
    )
}

// 🔹 Función auxiliar para extraer el videoId de una URL de YouTube
function getVideoId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
}
